export interface AppConfig {
  logtoEndpoint: string;
  logtoAppId: string;
  apiBase: string;
  apiResource: string;
}

declare global {
  interface Window {
    __DESKTOUCH_CONFIG__?: Partial<AppConfig>;
  }
}

/**
 * Runtime configuration, written to /config.js by the container entrypoint.
 * Without it (plain `vite dev`) the defaults target the docker compose dev
 * stack.
 */
const runtime = window.__DESKTOUCH_CONFIG__ ?? {};

export const config: AppConfig = {
  logtoEndpoint: runtime.logtoEndpoint || 'http://localhost:3001',
  logtoAppId: runtime.logtoAppId || '',
  apiBase: runtime.apiBase || 'http://localhost:3000',
  apiResource: runtime.apiResource || runtime.apiBase || 'http://localhost:3000',
};
